/**
 * Transforms the auth method response.
 *
 * @param response The response from the endpoint.
 */
export function transformAuthMethodResponse(response) {
    const magicLinkAuthMethod = response.data.auth_methods.find(({ type }) => type === 'dixa_magic_link');
    const oktaClientAuthMethod = response.data.auth_methods.find(({ type }) => type === 'okta_openid_connect');
    return {
        data: {
            auth_method: oktaClientAuthMethod !== null && oktaClientAuthMethod !== void 0 ? oktaClientAuthMethod : magicLinkAuthMethod,
        },
        meta: {},
    };
}
